/* JS for Product page sticky ATC bar - V */

document.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("sticky-atc-root");
  if (!root) return;

  const addBtn = root.querySelector("[data-sticky-atc-add]");
  const buyBtn = root.querySelector("[data-sticky-atc-buy-native]");
  const priceEl = root.querySelector("[data-sticky-price]");
  const optionsContainer = root.querySelector(".sticky-options");
  const productHandle = root.dataset.productHandle;
  const MOBILE_BREAKPOINT = 1024;

  let productData = null;
  let currentVariant = null;
  let combinedSelect = null;

  /* -------------------- Helpers -------------------- */
  const formatMoney = (cents) => {
    try {
      return Shopify.formatMoney(cents, "${{amount}}");
    } catch {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const fetchProduct = async () => {
    try {
      const res = await fetch(`/products/${productHandle}.js`);
      if (!res.ok) throw new Error("Failed to fetch product JSON");
      return await res.json();
    } catch (err) {
      // console.error("sticky-atc fetchProduct error:", err);
      return null;
    }
  };

  const updatePrice = () => {
    if (!priceEl) return;
    priceEl.textContent = currentVariant
      ? `Price: ${formatMoney(currentVariant.price)}`
      : "Price: -";
  };

  const setAddBtnLabel = (v) => {
    if (!addBtn) return;
    const txt = addBtn.querySelector(".atc-button--text");
    if (!v) {
      txt.textContent = "Unavailable";
      addBtn.disabled = true;
      return;
    }
    if (!v.available) {
      txt.textContent = "Sold Out";
      addBtn.disabled = true;
      return;
    }
    if ((v.title || "").toLowerCase().includes("pre-order") || window.location.pathname.includes("pre-order") || (document.body.innerHTML.toLowerCase().includes("data-product-atc-preorder"))) {
      txt.textContent = "Pre-Order";
      addBtn.disabled = false;
      return;
    }
    txt.textContent = "Add to Cart";
    addBtn.disabled = false;
  };

  const updateAddBtnVisibility = (available) => {
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    if (!addBtn) return;
    if (!available) {
      // addBtn.style.display = "inline-flex";
      addBtn.style.display = "none";
    } else {
      addBtn.style.display = isMobile ? "none" : "inline-flex";
    }
  };

  /* Adds to cart (used for Add to Cart and Buy Now flows) */
  const addToCartAjax = async (variantId, qty = 1) => {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      });
      return res.ok ? await res.json() : null;
    } catch (err) {
      // console.error("addToCartAjax error:", err);
      return null;
    }
  };

  /* Clear cart by calling /cart/clear.js (POST) */
  const clearCart = async () => {
    try {
      await fetch("/cart/clear.js", { method: "POST" });
    } catch (err) {
      console.warn("clearCart failed or not supported:", err);
    }
  };

  /* ---------- Native Buy Now flow ----------
     1) Clear cart
     2) Add variant
     3) Redirect to /checkout
  ------------------------------------------- */
  const handleBuyNowNative = async () => {
    if (!currentVariant || !currentVariant.available) return;

    // Disable buttons while processing
    buyBtn.disabled = true;
    // if (addBtn) addBtn.disabled = true;

    try {
      // 1) Clear cart - Update: Cart items are lost in case chekcout is abandoned - V 31 03 2026
      // await clearCart();

      // 2) Add selected variant
      //Update: Respect Quantity from product page selector - V 31 03 2026
        let qty = 1;
        const qtyInput = document.querySelector('[name="quantity"]');
        if(qtyInput){
          qty = parseInt(qtyInput.value, 10) || 1;
        }
      const added = await addToCartAjax(currentVariant.id, qty);
      if (!added) {
        // fallback: go to checkout anyway
        window.location.href = "/checkout";
        return;
      }

      // 3) Redirect to native checkout
      window.location.href = "/checkout";
    } catch (err) {
      // console.error("Buy Now native flow error:", err);
      buyBtn.disabled = false;
      if (addBtn) addBtn.disabled = false;
      // final fallback: add to cart old way then go to /cart
      try {
        await addToCartAjax(currentVariant.id, 1);
      } catch (e) {}
      window.location.href = "/cart";
    } finally {
      // re-enable
    //   buyBtn.disabled = false;
    //   if (addBtn) addBtn.disabled = false;
    }
  };

  /* ---------- Build combined dropdown for multi-variant ---------- */
  const buildCombinedDropdown = () => {
  if (!optionsContainer) return;
  optionsContainer.innerHTML = "";
  const wrap = document.createElement("div");
  wrap.className = "sticky-combined-wrapper";

  combinedSelect = document.createElement("select");
  combinedSelect.className = "sticky-combined-select";
  combinedSelect.setAttribute("aria-label", "Choose variant");

  productData.variants.forEach((v) => {
    const opt = document.createElement("option");
    opt.value = v.id;

    // Build label with attribute names + values
    let labelParts = [];

    // Adding SKU at the beginning of dropdown option - V 17 01 2026
    if(v.sku && v.sku.trim() !==""){
      labelParts.push(`SKU: ${v.sku}`);
    }

    productData.options.forEach((optObj, idx) => {
      const optName = typeof optObj === "object" ? optObj.name : optObj;
      const value = v[`option${idx + 1}`];
      if (value) labelParts.push(`${optName}: ${value}`);
    });

    const label = labelParts.join(" | ");
    opt.textContent = `${label} - Price: ${formatMoney(v.price)}`;

    if (!v.available) {
      opt.disabled = true;
      opt.textContent += " (Sold out)";
    }

    combinedSelect.appendChild(opt);
  });

  combinedSelect.addEventListener("change", () => {
    const id = combinedSelect.value;
    currentVariant =
      productData.variants.find((x) => String(x.id) === String(id)) || null;
    updatePrice();
    setAddBtnLabel(currentVariant);
    updateAddBtnVisibility(currentVariant?.available);
  });

  wrap.appendChild(combinedSelect);
  optionsContainer.appendChild(wrap);
};

  /* ---------- responsive handling ---------- */
  const applyResponsive = () => {
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    root.classList.toggle("sticky-mobile-mode", isMobile);
    updateAddBtnVisibility(currentVariant?.available);
  };

  /* ---------- Init ---------- */
  (async () => {
    productData = await fetchProduct();
    if (!productData) return;

    // pick initial variant: first available or first
    currentVariant =
      productData.variants.find((v) => v.available) || productData.variants[0];

    if (optionsContainer) buildCombinedDropdown();

    // set initial prices & labels
    updatePrice();
    setAddBtnLabel(currentVariant);
    updateAddBtnVisibility(currentVariant?.available);

    // Add handlers - version 1
    // addBtn?.addEventListener("click", async (e) => {
    //   e.preventDefault();
    //   if (!currentVariant?.available) return;
    //   // Add to cart and go to /cart
    //   addBtn.disabled = true;
    //   await addToCartAjax(currentVariant.id, 1);
    //   window.location.href = "/cart";
    // });

    // Add handlers - version 2 - Modified for Side cart
    addBtn?.addEventListener("click", async (e) => {
      e.preventDefault();
      if(!currentVariant?.available) return;

      addBtn.disabled = true;

      try{
        //Get Quantity from product page selector
        let qty = 1;
        const qtyInput = document.querySelector('[name="quantity"]');
        if(qtyInput){
          qty = parseInt(qtyInput.value, 10) || 1;
        }
        
        //For highlight inside Side cart
        window.lastAddedVariantId = currentVariant.id;

        //Enabling Add to cart via AJAX
        await addToCartAjax(currentVariant.id, qty);

        //Open side cart + Refresh
        window.refreshSideCart();
      } catch(err){
        console.error("Sticky ATC/Side Cart error:", err);
      } finally{
        addBtn.disabled = false;
      }
    });


    buyBtn?.addEventListener("click", async (e) => {
      e.preventDefault();
      await handleBuyNowNative();
    });

    applyResponsive();
    window.addEventListener("resize", applyResponsive);

    root.setAttribute("aria-hidden", "false");
  })();

});
